import { request, makePath } from './http';
const API_NAME = 'news';

export function getFeed(source=null, limit=30, offset=0) {
  return request('GET', makePath(API_NAME), {params: {source, limit, offset}});
}
